import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { X } from "lucide-react";

interface VideoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const VideoModal = ({ open, onOpenChange }: VideoModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="w-screen h-screen max-w-none max-h-none sm:max-w-4xl sm:w-[95vw] sm:h-auto p-0 bg-black border-none overflow-hidden rounded-none sm:rounded-lg"
        hideCloseButton={true}
      >
        <VisuallyHidden>
          <DialogTitle>Demo Video</DialogTitle>
        </VisuallyHidden>
        
        {/* Custom close button - always visible */}
        <button
          onClick={() => onOpenChange(false)}
          className="absolute right-3 top-3 z-50 p-1.5 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
          aria-label="Close video"
        >
          <X className="h-5 w-5 text-white" />
        </button>
        
        {/* Tap outside area on mobile - top and bottom black bars */}
        <div 
          className="absolute inset-0 sm:hidden" 
          onClick={() => onOpenChange(false)}
        />
        
        <div className="relative w-full h-full flex items-center pointer-events-none">
          <div className="relative w-full pointer-events-auto" style={{ paddingBottom: '56.25%' }}>
            {open && (
              <iframe
                src="https://player.vimeo.com/video/1149570669?autoplay=1&title=0&byline=0&portrait=0"
                className="absolute inset-0 w-full h-full"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
